// extracted by mini-css-extract-plugin
module.exports = {"container":"evaluationExperienceStudentPortal_container__3thKE","spinner":"evaluationExperienceStudentPortal_spinner__19g8v"};